module.exports = __webpack_public_path__ + "static/media/addActive.e43edf35.svg";